import {
  CreateApplicationDocument,
  CreateApplicationMutationVariables,
  GetApplicationPhasesDocument,
  JobPostingDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateApplication = () => {
  const [createApplication, { loading }] = useMutation(CreateApplicationDocument, {
    awaitRefetchQueries: true,
    extractorFn: (data) => data.atsMutations.createAtsApplication,
  })

  return {
    loading,
    create(variables: CreateApplicationMutationVariables) {
      return createApplication({
        variables,
        refetchQueries: [JobPostingDocument, GetApplicationPhasesDocument],
      })
    },
  }
}
